(() => {
  const pending = new Map();
  window.PILTRONReadCart = async function(url, options = {}) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);
    try { return await fetch(url, { ...options, signal: controller.signal }); }
    finally { clearTimeout(timer); }
  };
  window.PILTRONQuoteFetch = async function(url, options = {}) {
    const key = String(url) + '|' + String(options.body || '');
    if (!pending.has(key)) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 35000);
      const work = (async () => {
        try { return await fetch(url, { ...options, signal: controller.signal }); }
        catch (error) {
          if (error.name === 'AbortError') {
            const lang = (document.documentElement.lang || 'ar').slice(0, 2);
            throw new Error(lang === 'en' ? 'Price calculation timed out. Please retry.' :
              lang === 'de' ? 'Die Preisberechnung hat zu lange gedauert. Bitte erneut versuchen.' :
              'حساب السعر استغرق وقتًا أطول من المتوقع. حاول مرة أخرى.');
          }
          throw error;
        } finally { clearTimeout(timer); }
      })();
      pending.set(key, work);
      work.then(() => setTimeout(() => { if (pending.get(key) === work) pending.delete(key); }, 1000),
        () => { if (pending.get(key) === work) pending.delete(key); });
    }
    return (await pending.get(key)).clone();
  };
})();
